module.exports = __webpack_public_path__ + "img/631-98669d.png";